import ApiBase from "./ApiBase";

export default class VDI {

    static getUserStatus = function(query, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.getData("/api/vdi/getuserstatus",null,successCallback,errorCallback,alwaysCallback);
    }

    static register = function(query, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.postData("/api/vdi/register", query, successCallback, errorCallback, alwaysCallback);
    }

    static unregister = function(query, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.putData("/api/vdi/unregister",query,successCallback,errorCallback,alwaysCallback);
    }
}
